import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { FiSearch, FiX } from "react-icons/fi";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  label: string;
  className?: string;
  inputClassName?: string;
  size?: "default" | "compact";
  resultCount?: number;
  resultCountLabel?: (count: number) => string;
}

export const SearchInput = ({
  value,
  onChange,
  placeholder,
  label,
  className = "",
  inputClassName = "",
  size = "default",
  resultCount,
  resultCountLabel,
}: SearchInputProps) => {
  const { t } = useTranslation("common");
  const inputRef = useRef<HTMLInputElement | null>(null);

  return (
    <div role="search" aria-label={label} className={`relative ${className}`}>
      <FiSearch className="pointer-events-none absolute left-4 top-1/2 z-10 h-5 w-5 -translate-y-1/2 text-[var(--ds-ink-muted)]" aria-hidden="true" />
      <input
        ref={inputRef}
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Escape" && value) {
            event.preventDefault();
            onChange("");
          }
        }}
        placeholder={placeholder}
        aria-label={label}
        className={`app-search-input h-[52px] w-full rounded-[var(--ds-radius-md)] border-[1.5px] border-[var(--ds-ink-muted)] bg-[var(--ds-surface-raised)] pl-12 text-[var(--ds-ink)] outline-none placeholder:text-[var(--ds-ink-muted)] md:h-12 ${size === "compact" ? "text-sm" : "text-base"} ${value ? "pr-12" : "pr-4"} ${inputClassName}`}
      />
      {resultCount !== undefined && resultCountLabel ? (
        <span aria-live="polite" className="absolute right-14 top-1/2 -translate-y-1/2 text-xs text-[var(--ds-ink-muted)]">
          {resultCountLabel(resultCount)}
        </span>
      ) : null}
      {value ? (
        <button
          type="button"
          aria-label={t("actions.clear")}
          onClick={() => {
            onChange("");
            inputRef.current?.focus();
          }}
          className="app-focus-ring absolute right-1 top-1/2 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full text-[var(--ds-ink)] hover:bg-[var(--ds-ground)]"
        >
          <FiX className="h-4 w-4" aria-hidden="true" />
        </button>
      ) : null}
    </div>
  );
};
